export default {
  name: 'timer',
  component(expiryMs) {
    return {
      expiry: expiryMs,
      remaining: 0, // in seconds
      timerId: null,

      init() {
        this.setRemaining();
        this.timerId = setInterval(() => {
          this.setRemaining();
        }, 1000);

        this.$cleanup(() => {
          if (this.timerId) clearInterval(this.timerId);
        });
      },

      setRemaining() {
        const diff = this.expiry - new Date().getTime();
        // When the timer is finished, set remaining to 0 and clear the interval.
        // The `isFinished` getter will now automatically return true.
        if (diff <= 0) {
          this.remaining = 0;
          if (this.timerId) {
            clearInterval(this.timerId);
            this.timerId = null;
          }
          return;
        }
        this.remaining = Math.floor(diff / 1000);
      },

      /**
       * A getter that is accessed like a property (e.g., `isFinished`).
       * It derives its value from the reactive `remaining` property.
       */
      get isFinished() {
        return this.remaining <= 0;
      },

      days() {
        return {
          value: Math.floor(this.remaining / 86400),
          remaining: this.remaining % 86400
        };
      },

      hours() {
        return {
          value: Math.floor(this.days().remaining / 3600),
          remaining: this.days().remaining % 3600
        };
      },

      minutes() {
        return {
          value: Math.floor(this.hours().remaining / 60),
          remaining: this.hours().remaining % 60
        };
      },

      seconds() {
        return {
          value: this.minutes().remaining,
        };
      },

      format(value) {
        return String(Math.floor(value)).padStart(2, '0');
      },

      time() {
        return {
          days: this.format(this.days().value),
          hours: this.format(this.hours().value),
          minutes: this.format(this.minutes().value),
          seconds: this.format(this.seconds().value),
        }
      },
    }
  }
}
